import { Flex } from '@chakra-ui/react';
import ActivityList from './components/ActivityList';
import { MobileMenu } from './components/MobileMenu';
import { useParams } from 'react-router-dom';
import { ApplicationRoutes } from 'utils/routes';

const ActivityPage = () => {
  const { walletId, multisigAccountId } = useParams();

  return (
    <Flex
      flex={1}
      flexDirection="column"
    >
      <MobileMenu
        pageName='Activity'
        backUrl={`${ApplicationRoutes.Dashboard}/${walletId}/account/${multisigAccountId}`}
      />
      <ActivityList />
    </Flex>
  );
};

export default ActivityPage;
